import { useEffect, useState } from 'react';

// lightbox components
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

// @mui material components
import Stack from '@mui/material/Stack';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

function ProductImages({ selectedTemplate }) {
    const [currentImage, setCurrentImage] = useState(selectedTemplate?.offerImages[0]);
    const [lightbox, setLightbox] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    const handleSetCurrentImage = ({ currentTarget }) => {
        setCurrentImage(currentTarget.src);
        setLightboxIndex(Number(currentTarget.id));
    };

    useEffect(() => setCurrentImage(selectedTemplate?.offerImages[0]), [selectedTemplate]);

    const openLightbox = () => setLightbox(true);
    const closeLightbox = () => setLightbox(false);

    return (
        selectedTemplate && (
            <MDBox>
                {lightbox && (
                    <Lightbox
                        slides={selectedTemplate?.offerImages.map((img) => ({
                            src: img,
                        }))}
                        open={lightbox}
                        close={closeLightbox}
                        index={lightboxIndex}
                    />
                )}
                <MDBox
                    component="img"
                    src={currentImage}
                    alt="Product Image"
                    shadow="lg"
                    borderRadius="lg"
                    width="100%"
                    onClick={openLightbox}
                    sx={{ cursor: 'pointer' }}
                />
                <MDBox mt={2} pt={1}>
                    <Stack direction="row" spacing={3}>
                        {selectedTemplate?.offerImages?.map((img, index) => (
                            <MDBox
                                key={index}
                                component="img"
                                id={index}
                                src={img}
                                alt="small image 1"
                                borderRadius="lg"
                                shadow="md"
                                width="100%"
                                height="5rem"
                                minHeight="5rem"
                                sx={{
                                    cursor: 'pointer',
                                    objectFit: 'cover',
                                }}
                                onClick={handleSetCurrentImage}
                            />
                        ))}
                    </Stack>
                </MDBox>
            </MDBox>
        )
    );
}

export default ProductImages;
